export default {
  '主頁': '主頁',
  '一般查證': '一般查證',
  '大量查證': '大量查證',
  '上傳檔案': '上傳檔案',
  '下載查證結果': '下載查證結果',
  '下載格式': '下載格式',
  '大量查證失敗!請確認上傳格式是否正確，或聯絡開通中心 0800-222-179 ，謝謝': '大量查證失敗!請確認上傳格式是否正確，或聯絡開通中心 02-8227-3308分機20及21，謝謝',
  '補卡查證': '補卡查證',
  '升級查證': '升級查證',
  '門號查詢': '門號查詢',
  '查證紀錄': '查證紀錄',
  '問題紀錄': '問題紀錄',
  '登出': '登出',
  '快速功能': '快速功能',
  '快速搜尋': '快速搜尋',
  '近期記錄': '近期記錄',
  '日期': '日期',
  '證號': '證號',
  '結果': '結果',
  '狀態': '狀態',
  '當查證結果等待超過5分鐘時，請聯絡開通中心 02-8227-3308分機20及21，謝謝': '當查證結果等待超過5分鐘時，請聯絡開通中心 02-8227-3308分機20及21，謝謝',
  '已辦過': '已辦過',
  '已辦門號': '已辦門號',
  '欠費': '欠費',
  '風險': '風險',
  '有人查過': '有人查過',
  '護照號碼': '護照號碼',
  '目前身份': '目前身份',
  '門號': '門號',
  '身分證字號': '身分證字號',
  '身分證驗證': '身分證驗證',
  '請選擇證件類別': '請選擇證件類別',
  '請輸入證號': '請輸入證號',
  '居留證查詢': '居留證查詢',
  '請輸入生日': '請輸入生日',
  '生日 為必填': '生日 為必填',
  '國籍 為必填': '國籍 為必填',
  '生日': '生日',
  '國籍': '國籍',
  '泰國': '泰國',
  '印尼': '印尼',
  '越南': '越南',
  '菲律賓': '菲律賓',
  '印度': '印度',
  '其他': '其他',
  '中國': '中國',
  '確定': '確定',
  '確定送出': '確定送出',
  '查證系統': '查證系統',
  '請先登入系統': '請先登入系統',
  '手機號碼': '手機號碼',
  '取得簡訊驗證碼': '取得簡訊驗證碼',
  '認證碼': '認證碼',
  '重新發送驗證碼': '重新發送驗證碼',
  '登入系統': '登入系統',
  '驗證碼錯誤': '驗證碼錯誤',
  '系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。': '系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。',
  '此電話號碼不存在': '此電話號碼不存在',
  '無法取的認證碼，請聯絡開通中心 02-8227-3308分機20及21。': '無法取的認證碼，請聯絡開通中心 02-8227-3308分機20及21。',
  '問題件': '問題件',
  '辦門號': '辦門號',
  '系統編號': '系統編號',
  '門號類型': '門號類型',
  '辦門號記錄': '辦門號記錄',
  '一般門號': '一般門號',
  '升級': '升級',
  '換補卡': '換補卡',
  '卡號': '卡號',
  '此卡不在庫存內，請聯絡相關人員。': '此卡不在庫存內，請聯絡相關人員。',
  '聯絡電話': '聯絡電話',
  '預計開通日': '預計開通日',
  '仲介名': '仲介名',
  '認證電話': '認證電話',
  '看申請書': '看申請書',
  '中華申請書': '中華申請書',
  '請用正楷簽名': '請用正楷簽名',
  '確認簽名': '確認簽名',
  '請閱讀申請書並簽名': '請閱讀申請書並簽名',
  '請將 QRCODE 對準掃瞄框': '請將 QRCODE 對準掃瞄框',
  '掃描錯誤，內容如下:': '掃描錯誤，內容如下:',
  '您必須打開鏡頭權限': '您必須打開鏡頭權限',
  '找不到相機': '找不到相機',
  '相機已經被其他程式佔用': '相機已經被其他程式佔用',
  '系統無法支援此瀏覽器': '系統無法支援此瀏覽器',
  '重新掃描': '重新掃描',
  '清除': '清除',
  '取消': '取消',
  '我已閱讀{term}並同意加入九亨會員': '我已閱讀{term}並同意加入九亨會員',
  '閱讀條款': '閱讀條款',
  '請檢查所有欄位是否填寫正確': '請檢查所有欄位是否填寫正確',
  '送件': '送件',
  '暫存': '暫存',
  '關閉': '關閉',
  '刪除': '刪除',
  '上傳中': '上傳中',
  '讀取中': '讀取中',
  '送件完成': '送件完成',
  '暫存成功': '暫存成功',
  '抱歉！找不到此暫存件！': '抱歉！找不到此暫存件！',
  '確定刪除照片嗎？': '確定刪除照片嗎？',
  '確定要刪除此筆？所有的資料都會消失，此動作不可復原？': '確定要刪除此筆？所有的資料都會消失，此動作不可復原？',
  '刪除成功': '刪除成功',
  '抱歉！無法暫存，請稍後再試！': '抱歉！無法暫存，請稍後再試！',
  '全部': '全部',
  '抱歉！刪除失敗，請稍後再試！': '抱歉！刪除失敗，請稍後再試！',
  '未進件': '未進件',
  '已送件': '已送件',
  '預計開通': '預計開通',
  '已開通': '已開通',
  '已退卡': '已退卡',
  '已停話': '已停話',
  '照片張數 不得小於{0}': '照片張數 不得小於{0}',
  '門號 為必填': '門號 為必填',
  '卡號 為必填': '卡號 為必填',
  '門號不完整': '門號不完整',
  '抱歉! 無法暫存，請稍後再試!': '抱歉! 無法暫存，請稍後再試!',
  '照片數不能超過 7 張': '照片數不能超過 7 張',
  '回辦門號紀錄': '回辦門號紀錄',
  '繼續辦門號': '繼續辦門號',
  '回主畫面': '回主畫面',
  '查證': '查證',
  '我己閱讀並了解': '我己閱讀並了解',
  '如特定開通日期，才需點選': '如特定開通日期，才需點選',

  // 大量查證
  '班機': '班機',
  '班機狀態': '班機狀態',
  '未知': '未知(今天無此航班資訊)',
  '準時': '準時',
  '取消': '取消',
  '延誤': '延誤',
  '時間變更': '時間變更',
  '抵達': '抵達',
  '表定抵達時間': '表定抵達時間',
  '班機為必填': '班機為必填',
  '落地日期': '落地日期',
  '落地日期及時間 為必填': '落地日期及時間 為必填',
  '備註': '備註',
  '拍正反面：居留證、身份證、學生證、駕照': '拍正反面：居留證或護照、健保卡或簽證(VISA)含入境章或台灣駕照及人像照',
  '護照、簽證(VISA)、勞動契約及全身照': '護照、簽證(VISA)、勞動契約及人像照',
  '看申請書並正楷簽名': '看申請書並正楷簽名',
  '重簽名': '重簽名',
  '上傳照片': '上傳照片',
  '增加照片': '增加照片',
  '3張以上,最多7張': '3張以上,最多7張',
  '大量辦門號': '大量辦門號',
  '選取照片': '選取照片',
  '點擊上傳或是拖曳照片到畫面中': '點擊上傳或是拖曳照片到畫面中',
  '目前總共選取了{0}張照片': '目前總共選取了{0}張照片',
  '重新選擇': '重新選擇',
  '上傳照片': '上傳照片',
  '為了上傳更有效率，建議請將圖檔尺寸在 1200x1200 內。': '為了上傳更有效率，建議請將圖檔尺寸在 1200x1200 內。',
  '檔名': '檔名',
  '檔案大小': '檔案大小',
  '下一步': '下一步',
  '上傳失敗！請確認一下網路狀態，或是稍後再試。\n若持續有問題，請聯絡系統管理員。(請聯絡開通中心02-8227-3308分機20及21，謝謝)': '上傳失敗！請確認一下網路狀態，或是稍後再試。\n若持續有問題，請聯絡系統管理員。(請聯絡開通中心02-8227-3308分機20及21，謝謝)',
  '大量辦門號成功!': '大量辦門號成功!',
  '辦門號紀錄上傳中，請勿關閉視窗。': '辦門號紀錄上傳中，請勿關閉視窗。',
  'SIM卡庫存': 'SIM卡庫存',
  '庫存': '庫存',
  '類型': '類型',
  '動作': '動作',
  '照片數': '照片數',
  '上傳狀態': '上傳狀態',
  '上一步': '上一步',
  '目前比對出{0}筆可送件辦門號, 請確認': '目前比對出{0}筆可送件辦門號, 請確認',
  '暫存門號需有簽名才能比對': '暫存門號需有簽名才能比對',
  '單一門號照片數量,3張以上最多的7張': '單一門號照片數量,3張以上最多的7張',
  '照片檔要符合檔名規則09XXXXXXXX': '照片檔要符合檔名規則09XXXXXXXX',
  'API呼叫失敗': 'API呼叫失敗',

  // 問題件說明
  '問題件類型': '問題件類型',
  '問題件說明': '問題件說明',
  '證件': '證件',
  '欠費-本期.呆帳.拆機': '欠費-本期.呆帳.拆機',
  '簽名': '簽名',
  '未開通卡片遺失': '未開通卡片遺失',
  '台灣人': '台灣人',
  '未滿18歲': '未滿18歲',
  '日期輸入不正確': '日期輸入不正確',
  '流程重做': '流程重做',
  '升級.補卡資料不符': '升級.補卡資料不符',
  '非本人': '非本人',
  '人像照': '人像照',
  '補件': '補件',
  '其他': '其他',
  '[201]': '查核失敗，請稍後再試',
  '[OR1102]': '查核失敗，請稍後再試',
  '[OR4212]': '已辦過',
  '[OR421A]': '',
  '[OR421B]': '查核失敗，請稍後再試',
  '[OR421C]': '',
  '[OR5101]': '查核失敗，請稍後再試',
  '[OR5101]': '查核失敗，請稍後再試',
  '[OR4210]': '查核失敗，請稍後再試',
  '[OR4211]': '',
  '[OR4213]': '',
  '[OR4214]': '',
}
